import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ISimPublicationDetails } from '../../shared/models/document-publication-details';
@Component({
    selector: 'app-document-details-values',
    templateUrl: './document-details-values.component.html',
    styleUrl: './document-details-values.component.scss',
    standalone: false
})
export class DocumentDetailsValuesComponent {
  @Input() SIMPublicationDetails: ISimPublicationDetails | null = null;
  loading: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['SIMPublicationDetails']) {
      this.loading = false;
    }
  }
}
